import React from 'react';


export const Website = props => {
    return (
        <svg className={props.className} width="100" height="100" viewBox="0 0 100 100" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_306_2186)">
                <path d="M92.0408 1.15186H0V79.9519H92.0408V1.15186Z" fill="#C9E8FA"/>
                <path d="M92.0408 1.15186H0V16.9538H92.0408V1.15186Z" fill="#67BFFF"/>
                <path d="M92.0398 1.15186H46.0195V79.9519H92.0398V1.15186Z" fill="#B6E0F7"/>
                <path d="M92.0398 1.15186H46.0195V16.9538H92.0398V1.15186Z" fill="#0088FF"/>
                <path d="M74.0717 6.51855H70.0469V10.5434H74.0717V6.51855Z" fill="#F4F4F4"/>
                <path d="M80.3783 6.51855H76.3535V10.5434H80.3783V6.51855Z" fill="#F4F4F4"/>
                <path d="M86.6811 6.51855H82.6562V10.5434H86.6811V6.51855Z" fill="#F4F4F4"/>
                <path d="M65.2098 31.6021H26.8281V37.7245H65.2098V31.6021Z" fill="#67BFFF"/>
                <path d="M75.9445 44.3062H16.3262V55.4653H75.9445V44.3062Z" fill="white"/>
                <path d="M65.2094 31.6021H46.0195V37.7245H65.2094V31.6021Z" fill="#0088FF"/>
                <path d="M75.9439 44.3062H46.0195V55.4653H75.9439V44.3062Z" fill="#D9D8DB"/>
                <path
                    d="M99.9996 78.2624C99.9996 85.6788 96.0772 92.1788 90.1955 95.8012V95.8032C87.0607 97.7338 83.367 98.8481 79.4139 98.8481H79.3832C79.3443 98.8481 79.3057 98.8481 79.2668 98.8461C75.3668 98.8196 71.7279 97.7094 68.632 95.7993C67.3117 94.987 66.0893 94.0278 64.9893 92.9461C61.6832 89.6971 59.4689 85.342 58.9484 80.4768C58.8709 79.7502 58.8281 79.0116 58.8281 78.2625C58.8281 72.0932 61.5445 66.5584 65.8424 62.785C65.8893 62.7442 65.9363 62.7034 65.9832 62.6647C67.6588 61.2198 69.5709 60.0422 71.6506 59.1932C74.0037 58.236 76.573 57.6973 79.267 57.6809C79.316 57.679 79.365 57.679 79.4139 57.679C90.7832 57.6786 99.9996 66.8928 99.9996 78.2624Z"
                    fill="#FD7052"/>
                <path
                    d="M100 78.2623C100 85.6787 96.0779 92.1787 90.1963 95.8012V95.8031C87.0615 97.7338 83.3678 98.848 79.4147 98.848H79.384C79.3451 98.848 79.3064 98.848 79.2676 98.8461V57.6807C79.3166 57.6787 79.3656 57.6787 79.4145 57.6787C90.784 57.6785 100 66.8928 100 78.2623Z"
                    fill="#FF4F18"/>
                <path
                    d="M90.0486 85.2581V95.803C86.9139 97.7337 83.2201 98.8479 79.267 98.8479H79.2363L79.2506 85.2581L79.2648 72.0562L79.2709 66.4663L80.4402 68.503L82.4791 72.0562L89.2914 83.9378L90.0486 85.2581Z"
                    fill="#0088FF"/>
                <path
                    d="M79.2721 66.4644V66.4663L79.266 72.0562L79.2518 85.2581L79.2375 98.848C79.1986 98.848 79.16 98.848 79.1211 98.846C75.2211 98.8194 71.5822 97.7093 68.4863 95.7991V85.2563L69.2619 83.9013L76.0537 72.0564L79.1211 66.7136L79.268 66.4585L79.2721 66.4644Z"
                    fill="#67BFFF"/>
                <path
                    d="M68.4844 85.2583V85.2567L69.26 83.9016L76.0533 72.0567L79.2656 66.4583L79.2705 66.4655L82.4779 72.0567L89.2918 83.9372L90.0484 85.2583H68.4844Z"
                    fill="#FFC473"/>
                <path
                    d="M68.4844 85.2583V85.2567L69.26 83.9016L76.0533 72.0567L79.2656 66.4583L79.2705 66.4655L79.2512 85.2583H68.4844Z"
                    fill="#FFDBA8"/>
                <path d="M76.0547 72.0561L79.2664 66.4583L79.2709 66.4651L82.4779 72.0561H76.0547Z" fill="#3C3A41"/>
                <path d="M79.2648 72.0561H76.0547L79.2664 66.4583L79.2709 66.4651L79.2648 72.0561Z" fill="#57555C"/>
            </g>
            <defs>
                <clipPath id="clip0_306_2186">
                    <rect width="100" height="100" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    )
};
